import { render, staticRenderFns } from "./information-system.vue?vue&type=template&id=03bf5024&scoped=true&"
import script from "./information-system.vue?vue&type=script&lang=js&"
export * from "./information-system.vue?vue&type=script&lang=js&"
import style0 from "./information-system.vue?vue&type=style&index=0&id=03bf5024&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bf5024",
  null
  
)

export default component.exports